import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './App.css';

// Composants pour chaque langue
const RecetteFrancais = () => (
  <div className="recipe-container">
    <header>
      <nav className="language-nav">
        <Link to="/sl">Slovenščina</Link>
        <Link to="/fr">Français</Link>
        <Link to="/en">English</Link>
      </nav>
    </header>

    <main>
      <h1>Gâteau aux Myrtilles</h1>

      <div className="recipe-image">
        <img src="/images/gateau.jpeg" alt="Gâteau aux myrtilles" />
      </div>

      <div className="recipe-content">
        <h2>Ingrédients</h2>
        <ul>
          <li>40g de fécule</li>
          <li>40g de farine</li>
          <li>3 œufs</li>
          <li>90g de sucre + 50g pour les blancs en neige</li>
          <li>30 à 40cl de crème fraîche pour la chantilly</li>
          <li>1 cuillère à soupe de kirsch</li>
          <li>200g de myrtilles fraîches</li>
          <li>Beurre pour le moule</li>
        </ul>

        <h2>Préparation</h2>
        <ol>
          <li><strong>Préparation du biscuit :</strong> Cassez les œufs en séparant les blancs des jaunes. Mélangez les jaunes avec 90g de sucre en poudre et travaillez à la cuillère de bois pour obtenir une pâte blanche et mousseuse. Ajoutez à cette pâte, par petites quantités, la farine et la fécule.</li>
          <li><strong>Blancs en neige :</strong> Battez les blancs en neige très ferme. Quand ils commencent à monter, ajoutez les 50g de sucre restants.</li>
          <li><strong>Incorporation :</strong> Incorporez ces blancs à la préparation précédente en la soulevant sans la battre. Allumez le four à température douce.</li>
          <li><strong>Préparation du moule :</strong> Beurrez un moule à gâteau circulaire, pour qu'il soit assez épais pour le couper en 2 quand il sera refroidi.</li>
          <li><strong>Cuisson :</strong> Cuisez à 180°C pendant 15 minutes.</li>
          <li><strong>Montage final :</strong> Préparez une chantilly à laquelle vous ajoutez les myrtilles. Après avoir humecté le gâteau (un peu d'eau et de kirsch par exemple, ou une autre liqueur, facultatif, et à peine de sucre), étalez la chantilly aux myrtilles sur la moitié du gâteau avant de recouvrir avec la 2ème moitié.</li>
        </ol>

        <div className="bon-appetit">
          <p>Bon appétit !</p>
        </div>

      </div>
    </main>
  </div>
);

const RecipeEnglish = () => (
  <div className="recipe-container">
    <header>
      <nav className="language-nav">
        <Link to="/sl">Slovenščina</Link>
        <Link to="/fr">Français</Link>
        <Link to="/en">English</Link>
      </nav>
    </header>

    <main>
      <h1>Blueberry Cake</h1>

      <div className="recipe-image">
        <img src="/images/gateau.jpeg" alt="Blueberry cake" />
      </div>

      <div className="recipe-content">
        <h2>Ingredients</h2>
        <ul>
          <li>40g cornstarch</li>
          <li>40g flour</li>
          <li>3 eggs</li>
          <li>90g sugar + 50g for the egg whites</li>
          <li>30 to 40cl heavy cream for whipping</li>
          <li>1 tablespoon kirsch</li>
          <li>200g fresh blueberries</li>
          <li>Butter for the pan</li>
        </ul>

        <h2>Instructions</h2>
        <ol>
          <li><strong>Sponge preparation:</strong> Crack the eggs and separate whites from yolks. Mix the yolks with 90g sugar and work with a wooden spoon to obtain a white and fluffy paste. Add to this mixture, in small quantities, the flour and cornstarch.</li>
          <li><strong>Egg whites:</strong> Beat the whites until very stiff peaks form. When they start to mount, add the remaining 50g sugar.</li>
          <li><strong>Folding:</strong> Incorporate these whites into the previous preparation by lifting without beating. Turn on the oven to gentle temperature.</li>
          <li><strong>Pan preparation:</strong> Butter a circular cake pan, so it's thick enough to cut in half when cooled.</li>
          <li><strong>Baking:</strong> Bake at 180°C for 15 minutes.</li>
          <li><strong>Final assembly:</strong> Make whipped cream and add the blueberries. After moistening the cake (a little water and kirsch for example, or another liqueur, optional, and barely any sugar), spread the blueberry cream on half of the cake before covering with the 2nd half.</li>
        </ol>

        <div className="bon-appetit">
          <p>Enjoy your meal!</p>
        </div>


      </div>
    </main>
  </div>
);

const RecipeSlovene = () => (
  <div className="recipe-container">
    <header>
      <nav className="language-nav">
        <Link to="/sl">Slovenščina</Link>
        <Link to="/fr">Français</Link>
        <Link to="/en">English</Link>
      </nav>
    </header>

    <main>
      <h1>Borovničeva Torta</h1>

      <div className="recipe-image">
        <img src="/images/gateau.jpeg" alt="Borovničeva torta" />
      </div>

      <div className="recipe-content">
        <h2>Sestavine</h2>
        <ul>
          <li>40g škroba</li>
          <li>40g moke</li>
          <li>3 jajca</li>
          <li>90g sladkorja + 50g za beljake</li>
          <li>30 do 40cl smetane za stepanje</li>
          <li>1 žlica kirsch</li>
          <li>200g svežih borovnic</li>
          <li>Maslo za posodo</li>
        </ul>

        <h2>Priprava</h2>
        <ol>
          <li><strong>Priprava biskvita:</strong> Razbijte jajca in ločite beljake od rumenjakov. Zmešajte rumenjake z 90g sladkorja in delajte z leseno žlico, da dobite belo in puhasto maso. Dodajte tej masi, v manjših količinah, moko in škrob.</li>
          <li><strong>Beljaki:</strong> Stepite beljake v zelo trd sneg. Ko se začnejo dvigovati, dodajte preostali sladkor (50g).</li>
          <li><strong>Vmešavanje:</strong> Vključite te beljake v prejšnjo pripravo tako, da jih dvigujete, ne stepajte. Vklopite pečico na nežno temperaturo.</li>
          <li><strong>Priprava posode:</strong> Namastite okroglo posodo za torto, da bo dovolj debela, da jo lahko razrežete na pol, ko se ohladi.</li>
          <li><strong>Pečenje:</strong> Pecite pri 180°C 15 minut.</li>
          <li><strong>Končno sestavljanje:</strong> Pripravite stepeno smetano in dodajte borovnice. Ko navlažite torto (malo vode in kirsch na primer, ali drugo likerko, po želji, in komaj sladkorja), razporedite borovničevo smetano na polovico torte, preden pokrijete z drugo polovico.</li>
        </ol>

        <div className="bon-appetit">
          <p>Dober tek!</p>
        </div>

      </div>
    </main>
  </div>
);

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<RecipeSlovene />} />
          <Route path="/fr" element={<RecetteFrancais />} />
          <Route path="/en" element={<RecipeEnglish />} />
          <Route path="/sl" element={<RecipeSlovene />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;